import media_airplay from './media-airplay.svg';
import media_chromecast from './media-chromecast.svg';
import media_forward from './media-forward.svg';
import media_headphones from './media-headphones.svg';
import media_image_01 from './media-image-01.svg';
import media_image_02 from './media-image-02.svg';
import media_pause from './media-pause.svg';
import media_pause_circle from './media-pause-circle.svg';
import media_play from './media-play.svg';
import media_play_circle from './media-play-circle.svg';
import media_rewind from './media-rewind.svg';
import media_shuffle from './media-shuffle.svg';
import media_skip_back from './media-skip-back.svg';
import media_skip_forward from './media-skip-forward.svg';
import media_stop from './media-stop.svg';
import media_stop_circle from './media-stop-circle.svg';

export const V2_MEDIA_ICONS: { [char: string]: string } = {
  media_airplay,
  media_chromecast,
  media_forward,
  media_headphones,
  media_image_01,
  media_image_02,
  media_pause,
  media_pause_circle,
  media_play,
  media_play_circle,
  media_rewind,
  media_shuffle,
  media_skip_back,
  media_skip_forward,
  media_stop,
  media_stop_circle,
};

export const V2_MEDIA_ICON_NAMES: string[] = Object.keys(V2_MEDIA_ICONS);
